export const cafeButtons = [
    {
        id: "info",
        text: "Изменить информацию о предприятии",
        path: `editInfo`,
    },
    {
        id: "kpi",
        text: "План по выручке",
        path: `kpi`,
    },
    {
        id: "zones",
        text: "Зоны чек-листов",
        path: "zones",
    },
    {
        id: "employees",
        text: "Сотрудники",
        path: `employees`,
    },
    {
        id: "table",
        text: "Табель",
        path: `table`,
    },
    {
        id: "knowledge",
        text: "База знаний",
        path: `knowledge`,
    },
    {
        id: "faq",
        text: "FAQ",
        path: `faq`,
    },
    {
        id: "reports",
        text: "Отчеты по чек-листам",
        path: "reports",
    },
]